import styles from './styles.module.scss'

function OrderPageSkeletonItem() {
  return (
    <div className={styles.OrderPageSkeleton_list}>
      <div className={`${styles.image} ${styles['skeleton-content']}`}></div>
      <div className={styles.details}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={styles.reoder}></div>
    </div>
  )
}

export default function OrderListItemSkeleton() {
  return (
    <div className={styles.OrderItemSkeleton}>
      <div className={styles.OrderItem}>
        <div className={styles.OrderPageSkeleton_header}>
          <div className={styles['skeleton-content']}></div>
          <div className={styles['skeleton-content']}></div>
          <div className={styles['skeleton-content']}></div>
        </div>
        <OrderPageSkeletonItem />
      </div>
    </div>
  )
}
